import Authentication from "../services/Authentication.js"

export const state = () => ({
  userStatus: {},
  featureData: {}
})

export const mutations = {
  SET_FEATURE_DATA(state, featureData) {
    state.featureData = featureData
  },
  SET_USER_STATUS(state, userStatus) {
    state.userStatus = userStatus
  }
}

export const actions = {
  fetchFeatureData({ commit }, { useLegacyAuthentication }) {
    Authentication.getFeaturesStates({
      useLegacyAuthentication
    }).then(response => {
      if (response.data) {
        commit("SET_FEATURE_DATA", response.data)
      }
    })
  },
  fetchUserStatus({ commit }, { useLegacyAuthentication }) {
    Authentication.checkLoginStatus({
      useLegacyAuthentication
    }).then(response => {
      if (response.data) {
        commit("SET_USER_STATUS", response.data)
      }
    })
  }
}

export const getters = {
  isLoggedIn: state => state.userStatus && state.userStatus.userSignedIn,
  hasMultipleAccounts: state =>
    state.userStatus && state.userStatus.multipleAccounts
}
